import { render, staticRenderFns } from "./ExhibitionPageMain.vue?vue&type=template&id=3d323f84&"
import script from "./ExhibitionPageMain.vue?vue&type=script&lang=js&"
export * from "./ExhibitionPageMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d323f84')) {
      api.createRecord('3d323f84', component.options)
    } else {
      api.reload('3d323f84', component.options)
    }
    module.hot.accept("./ExhibitionPageMain.vue?vue&type=template&id=3d323f84&", function () {
      api.rerender('3d323f84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Visitors/ExhibitionPage/ExhibitionPageMain.vue"
export default component.exports